import {Pagination, Table} from "antd";
import {renderDate} from "../../../../utils";
import {Button, StatusLabel} from "../../../../components";
import {Link} from "react-router-dom";

function TicketTable({items = [], pagination, onPaginationChange})
{
    const columns = [
        {
            title: "Mã Ticket",
            dataIndex: "code",
            key: "code",
            width: 100,
            render: (_, item) => {
                return (<Link to={`/ticket/detail/${item.id}`}>TK{item.id}</Link>)
            }
        },
        {
            title: "Khách hàng",
            dataIndex: "customer",
            key: "customer",
            width: 200,
            render: (_, item) => {
                return (<>
                    <p>{item.customer.code} - {item.customer.name}</p>
                    <p>{item.customer.phone}</p>
                </>)
            }
        },
        {
            title: "Loại Ticket",
            dataIndex: "type",
            key: "type",
            width: 150,
            render: (_, item) => {
                return (<span>{item.typeName}</span>)
            }
        },
        {
            title: "Ticket",
            dataIndex: "title",
            key: "title",
            render: (_, item) => {
                return (<span>{item.title}</span>)
            }
        },
        {
            title: "Ngày tạo",
            dataIndex: "created",
            key: "created",
            width: 200,
            render: (_, item) => {
                return <span>{item.created}</span>;
            }
        },
        {
            title: "Tình trạng",
            dataIndex: "status",
            key: "status",
            width: 120,
            render: (_, item) => {
                return <span><StatusLabel type={item.status.badge}>{item.status.label}</StatusLabel></span>;
            }
        },
        {
            title: "Dịch vụ",
            dataIndex: "service",
            key: "service",
            width: 200,
            render: (_, item) => {
                return <span>{item.serviceName}</span>;
            }
        },
        {
            title: "Trả lời cuối",
            dataIndex: "comment",
            key: "comment",
            width: 200,
            render: (_, item) => {
                return (item?.isCustomerComment === 1) ? <span className={'color-red'}>Đã có trả lời</span> : <span className={'color-grey'}>Chưa có phản hồi</span>
            }
        },
        {
            title: '#',
            dataIndex: 'action',
            key: "action",
            width: '220px',
            render: (_, item) => {
                return <Button small background blue className="w-100" to={`/ticket/detail/${item.id}`}>Xem chi tiết</Button>
            }
        }
    ]

    const dataSource= items.map(row => ({
        key: row.id, // I added this line
        ...row
    }));

    return (
        <div className="table-wrapper">
            <div className="table-box">
                <Table columns={columns} dataSource={dataSource} scroll={{ y:550 }} pagination={false} />
            </div>
            <Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.totalRows} onChange={onPaginationChange}  showSizeChanger={false} />
        </div>
    )
}

export default TicketTable;